export default {
  cookies: {
    title: 'Wir respektieren Ihre Privatsphäre',
    description:
      'Wir verwenden Cookies, um die ordnungsgemäße Funktion unserer Website sicherzustellen, den Verkehr zu analysieren und unseren Service zu verbessern. Sie können Cookies akzeptieren oder ablehnen. Ihre Entscheidung kann später geändert werden.',
    accept: 'Alle akzeptieren',
    reject: 'Ablehnen',
    privacy_policy: 'Datenschutzrichtlinie'
  }
}
